import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { RouterLink, RouterOutlet } from '@angular/router'
import {
  IxApplication,
  IxApplicationHeader,
  IxContent,
  IxMenu,
  IxMenuAbout,
  IxMenuItem,
  IxMenuSettings,
} from '@siemens/ix-angular/standalone'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { map } from 'rxjs'
import { AppVersion } from '../environments/app.version'
import { SettingsComponent } from './core/settings/settings.component'
import { AboutInfoComponent } from './modules/about/about-info.component'
import { UserAuthComponent } from './core/auth/user-auth.component'
import { addIcons } from '@siemens/ix-icons'
import {
  iconAi,
  iconChevronRightSmall,
  iconClear,
  iconDownload,
  iconDownloadFull,
  iconEye,
  iconEyeCancelled,
  iconFeedbackFilled,
  iconHome,
  iconLineDashDot,
  iconLineDiagonal,
  iconLogIn,
  iconLogOut,
  iconSearch,
  iconThumbDownFilled,
  iconThumbUpFilled,
} from '@siemens/ix-icons/icons'

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    IxApplication,
    IxApplicationHeader,
    IxMenu,
    IxMenuItem,
    IxMenuAbout,
    IxMenuSettings,
    IxContent,
    TranslatePipe,
    SettingsComponent,
    AboutInfoComponent,
    RouterLink,
    UserAuthComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  translateService = inject(TranslateService)

  constructor() {
    addIcons({
      iconChevronRightSmall,
      iconLogIn,
      iconHome,
      iconLogOut,
      iconSearch,
      iconClear,
      iconLineDiagonal,
      iconEye,
      iconEyeCancelled,
      iconThumbUpFilled,
      iconThumbDownFilled,
      iconFeedbackFilled,
      iconAi,
      iconDownload,
      iconLineDashDot,
      iconDownloadFull,
    })
  }

  readonly applicationName = toSignal(
    this.translateService
      .getStreamOnTranslationChange('APP.NAME')
      .pipe(map((appName) => (AppVersion.flavor === 'PRD' ? appName : `${appName} (${AppVersion.flavor})`))),
    { initialValue: 'APP.NAME' },
  )
}
